export interface IHAL {
	_links: Object,
	_embedded: Object,
	_refs?: IRefs,
}

export interface IRefs {
	nomenclature: string,
	exercise: string,
	hypothesis: string,
	config: string,
	dataset: string
}


export interface IEmbeddedLinks {
	_links: {
		self: { href: string },
		find: { href: string }
	}
	_refs?: IRefs,
}
export interface IFindObject extends IEmbeddedLinks {
	count: number,
	params: IURLParams
}
export interface IDefaultObject extends IHAL {
	id: string,
	cid: string,
	d: number
}

export interface IURLParams {
	c?: string, // class
	d?: number, // Deepth
	o?: string, // owner
	q?: Array<any>,
	f?: IFilter[],
	l?: string, // limit
	p?: string, // pagin
	r?: string, // realm
}

export interface IFilter {
	k?: IFilterParams[];
}
export interface IFilterParams {
	o?: string, // owner
	v?: string, // value
}
// export interface IActionEventParams {
// 	action: EActionEvent,
// 	data: Object
// }
export class HAL implements IHAL {
	"_links": Object;
	"_embedded": Object;
}

export class URLParams implements IURLParams {
	d: number;
	c?: string;
	o?: string;
	f?: Filter[];
	l?: string;
	p?: string;
	r?: string;
}

export class Filter implements IFilter {
	k?: FilterParams[];
}

export class FilterParams implements IFilterParams {
	o?: string; // owner
	v?: string; // value
}
